<template>
  <div>
    <head-nav-bar title="支付结果" :fixed="true" />
    <div class="mt-header-nav">
      <result :state="state" :title="title" />
      <div style="padding:20px">
        <!-- <van-button block v-if="state == 'warning'">刷新</van-button> -->
        <van-button block @click="toHome">返回首页</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import Result from "@/components/result";
import restaurantApi from "@/api/restaurant.js";
import { mapState } from "vuex";
import { Button } from "vant";

export default {
  components: {
    Result,
    [Button.name]: Button,
  },
  data() {
    return {
      state: "wait",
      title: "支付处理中",
      payOrderId: "",
    };
  },
  computed: {
    ...mapState({
      wechatUserInfo: state => state.user.wechatUserInfo,
      restaruantInfo: state => state.user.restaruantInfo,
    }),
  },
  created() {
    this.orderId = this.$route.query.OrderId;
    this.tableId = this.$route.query.TableId;
    this.payOrderId = this.$route.query.PayOrderId;
    this.getPayResult();
  },
  methods: {
    getPayResult() {
      restaurantApi
        .getPayResult({
          RestaurantOrderId: this.orderId,
          PayOrderId: this.payOrderId,
          IsSettleAfterCheck: true,
        })
        .then(() => {
          this.state = "success";
          this.title = "支付成功";
        })
        .catch(() => {
          this.state = "warning";
          this.title = "处理超时";
        });
    },
    toHome() {
      this.$router.push({
        name: "restaurantIndex",
        query: {
          TableId: this.tableId,
          CompanyId: this.restaruantInfo.CompanyId,
        },
      });
    },
  },
};
</script>
